import request from '@/request/ts-index';
import request2 from '@/request/ts-index2';
import qs from 'qs';
var TelecomApi;
(function (TelecomApi) {
    TelecomApi["packageList"] = "/telecom/package/list";
    TelecomApi["addtoneFree"] = "/telecom/addtone/free";
    TelecomApi["unsubscribe"] = "/telecom/unsubscribe/emp";
    TelecomApi["conflictPkg"] = "/telecom/conflict-packages";
})(TelecomApi || (TelecomApi = {}));
export const packageList = (mobile) => {
    return request.get(TelecomApi.packageList, { params: { mobile } });
};
export const addtoneFree = (data) => {
    return request.post(TelecomApi.addtoneFree, qs.stringify(data));
};
// eslint-disable-next-line camelcase
export const unsubscribeTelecom = (data) => {
    return request2.post(TelecomApi.unsubscribe, data);
};
export const conflictPkgTelecom = (data) => {
    return request2.post(TelecomApi.conflictPkg, data);
};
